import React from "react";
import { Box, Card, IconButton, Typography } from "@mui/material";
import { Eye } from "lucide-react";
import styles from "./socDashboard.module.scss";

const alerts = [
  {
    severity: "critical",
    alert: "Unauthorized Access Attempt - SCADA",
    source: "192.168.100.45",
    time: "2m ago",
    status: "investigating",
  },
  {
    severity: "high",
    alert: "Anomalous Network Traffic Pattern",
    source: "OT-Network-3",
    time: "8m ago",
    status: "contained",
  },
  {
    severity: "high",
    alert: "Multiple Failed Login Attempts",
    source: "VPN-Gateway",
    time: "15m ago",
    status: "resolved",
  },
  {
    severity: "medium",
    alert: "Suspicious Process Execution",
    source: "WS-Floor-12",
    time: "22m ago",
    status: "monitoring",
  },
  {
    severity: "critical",
    alert: "Policy Violation - External Partner Zone",
    source: "10.20.30.15",
    time: "31m ago",
    status: "escalated",
  },
];

const severityClass = {
  critical: styles.sevCritical,
  high: styles.sevHigh,
  medium: styles.sevMedium,
};

const statusClass = {
  investigating: styles.statusInvestigating,
  contained: styles.statusContained,
  resolved: styles.statusResolved,
  monitoring: styles.statusMonitoring,
  escalated: styles.statusEscalated,
};

export const SocRecentAlerts = () => {
  return (
    <Card className={`${styles.card} ${styles.tableCard}`}>
      <Box className={styles.tableHeader}>
        <Typography className={styles.timelineTitle}>Recent Alerts</Typography>
        <Typography
          variant="body2"
          color="primary"
          sx={{ fontWeight: 700, cursor: "pointer" }}
        >
          View All Alerts
        </Typography>
      </Box>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Severity</th>
            <th>Alert</th>
            <th>Source</th>
            <th>Time</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {alerts.map((item, idx) => (
            <tr key={idx}>
              <td>
                <span
                  className={`${styles.badge} ${severityClass[item.severity]}`}
                >
                  {item.severity}
                </span>
              </td>
              <td>{item.alert}</td>
              <td style={{ color: "#0CA6F2" }}>{item.source}</td>
              <td>{item.time}</td>
              <td>
                <span
                  className={`${styles.status} ${statusClass[item.status]}`}
                >
                  {item.status}
                </span>
              </td>
              <td>
                <IconButton size="small">
                  <Eye size={16} />
                </IconButton>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
};

export default SocRecentAlerts;
